module.exports = __webpack_public_path__ + "img/hc_pro_ten_12.3d97d107.jpg";